import { PropsWithChildren } from 'react';
import { layoutGridStyle } from './layoutVertical.styles.css';

const LayoutVertical: React.FC<PropsWithChildren<unknown>> = ({ children }) => {
    return <div className={layoutGridStyle}>{children}</div>;
};

export { LayoutVertical };
